import React from 'react';
import { ReactComponent as ListPoint } from '../../lib/img/list-point.svg';

const getListItem = (name: string, mtListItem?: number): React.ReactElement<any, any> => (
  <div className={`mt${mtListItem}`}>
    <ListPoint className="mr8" />
    {name}
  </div>
);

interface Props {
  mtListItem?: number;
}

function PasswordHint({ mtListItem = 16 }: Props) {
  return (
    <div className="font-roboto text-left">
      {getListItem('Строчные латинские буквы a-z', mtListItem)}
      {getListItem('Заглавные буквы A-Z', mtListItem)}
      {getListItem('Цифры', mtListItem)}
      {getListItem('Специальные символы !@#$%^&*-.', mtListItem)}
    </div>
  );
}

export default PasswordHint;
